import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../cn';
/**
 * Card — surface container. Compose with CardHeader, CardBody, CardFooter.
 *
 * Replaces the mockup class `.card`.
 *
 * @example
 *   <Card>
 *     <CardHeader title="Produits en rupture" sub="Suggestions IA" actions={<Button>Filtrer</Button>} />
 *     <CardBody flush><Table /></CardBody>
 *   </Card>
 */
export const Card = forwardRef(function Card({ flat = false, className, ...rest }, ref) {
    return (_jsx("div", { ref: ref, className: cn('bg-white rounded-[10px]', !flat && 'border border-slate-200', className), ...rest }));
});
export const CardHeader = forwardRef(function CardHeader({ title, sub, icon, actions, className, children, ...rest }, ref) {
    return (_jsxs("div", { ref: ref, className: cn('px-[16px] py-[14px] border-b border-slate-200 flex items-center gap-[10px]', className), ...rest, children: [icon ? _jsx("span", { className: "inline-flex shrink-0 text-slate-500", children: icon }) : null, title || sub ? (_jsxs("div", { className: "min-w-0 flex-1", children: [title ? _jsx("div", { className: "font-semibold text-slate-900 truncate", children: title }) : null, sub ? _jsx("div", { className: "text-slate-500 text-[12px] truncate", children: sub }) : null] })) : null, children, actions ? (_jsx("div", { className: "ml-auto flex items-center gap-[6px] flex-wrap max-w-full min-w-0 justify-end", children: actions })) : null] }));
});
export const CardBody = forwardRef(function CardBody({ flush = false, className, ...rest }, ref) {
    return (_jsx("div", { ref: ref, className: cn(flush ? 'p-0' : 'p-[16px]', className), ...rest }));
});
export const CardFooter = forwardRef(function CardFooter({ className, ...rest }, ref) {
    return (_jsx("div", { ref: ref, className: cn('px-[16px] py-[12px] border-t border-slate-200 flex items-center gap-[8px]', className), ...rest }));
});
//# sourceMappingURL=Card.js.map